import BaseRouter from 'nast-router'

/**
 *
 */
export default class NastRouter extends BaseRouter {

}
